import { render, staticRenderFns } from "./sw_examples.vue?vue&type=template&id=6ddf50a2&scoped=true"
import script from "./sw_examples.vue?vue&type=script&lang=js"
export * from "./sw_examples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddf50a2",
  null
  
)

export default component.exports